import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import GuidanceCallout from "./atoms/guidance-callout/GuidanceCallout";
import "./NoPermissionAlert.scss";

function NoPermissionAlert({
	messageKey = "common.no-permission",
	message,
	titleKey = "projects.no-access-title",
	title,
	showBackButton = false,
	backTo = "/projects",
}) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const actions = useMemo(() => {
		if (!showBackButton) return undefined;
		return [
			{
				label: t("common.back-to-projects"),
				onClick: () => navigate(backTo),
				variant: "primary",
			},
		];
	}, [showBackButton, backTo, navigate, t]);

	return (
		<div className="no-permission-screen d-flex justify-content-center align-items-center p-4 p-md-5">
			<div className="no-permission-screen__content">
				<GuidanceCallout
					variant="warning"
					title={title ?? t(titleKey)}
					message={message ?? t(messageKey)}
					actions={actions}
				/>
			</div>
		</div>
	);
}

export default NoPermissionAlert;
